import { Tabs, TabsList, TabsListItem } from '@coolblue-development/freddy';
import { useEffect, useState } from 'react';
import { Page } from '../../../models/Page';
import { useAppContext } from '../../../AppContext';
import { IsB2bAgent } from '../../../utils/isB2bAgent';
import { calculateTotalUnread } from '../../../utils/calculateTotalUnread';
import { useChatContext } from '../../../contexts/ChatContext';
import { useEmailContext } from '../../../contexts/EmailContext';
import { Label } from '../Label';

const Channels = (): JSX.Element => {
  const { setActivePage, activePage } = useAppContext();
  const { selectedChat, unreadMessages } = useChatContext();
  const { emailContacts } = useEmailContext();
  const menuItems: Page[] = [Page.TELEPHONY, ...(!IsB2bAgent() ? [Page.CHAT] : []), Page.EMAIL];
  const [totalCount, setTotalCount] = useState<number>(0);

  useEffect(() => {
    let totalUnreadCount = 0;
    totalUnreadCount = calculateTotalUnread(unreadMessages);

    setTotalCount(totalUnreadCount);
  }, [selectedChat, unreadMessages]);

  return (
    <Tabs
      value={menuItems.includes(activePage) ? activePage : ''}
      onChange={value => setActivePage(value as Page)}
      translations={{ ariaLabelPrev: 'Previous', ariaLabelNext: 'Next' }}
      sx={{ '& > div': { width: '100%' }, '& [role="tab"]': { minHeight: '60px' } }}
    >
      <TabsList>
        {menuItems.map(item => (
          <TabsListItem key={item} value={item}>
            {item}
            {item === Page.CHAT && totalCount > 0 && (
              <Label data-testid="unreadMessageCount" color="orange" sx={{ marginLeft: '10px' }}>
                {totalCount}
              </Label>
            )}
            {item === Page.EMAIL && emailContacts.length > 0 && (
              <Label data-testid="activeEmailCount" color="orange" sx={{ marginLeft: '10px' }}>
                {emailContacts.length}
              </Label>
            )}
          </TabsListItem>
        ))}
      </TabsList>
    </Tabs>
  );
};

export default Channels;
